import HundredBricksAPIError from '@lib/hundredBricksAPI/HundredBricksAPIError';
class CurrentFundsBalanceError extends HundredBricksAPIError {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(...args) {
        super('CurrentFundsBalanceError', ...args);
    }
}
export default CurrentFundsBalanceError;
